import React, { useEffect, useState } from 'react';
import { Card, Form, Input, Button, Row, Col, Space, Breadcrumb } from 'antd';
import { showSuccess, showError } from '../../../../components/errorHandler';
import { apiRequest } from '../../../../service/apiRequest';

const EmailSettings: React.FC = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSave = async (values: any) => {
    try {
      await apiRequest({
        method: 'put',
        url: '/save-email-setting', // ✅ your backend endpoint
        data: values,
      });
      showSuccess('Email settings saved successfully');
    } catch (error) {
      showError('Failed to save email settings');
    }
  };

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        setLoading(true);
        const response = await apiRequest({ method: 'get', url: '/email-setting' });
        console.log('Fetched email settings:', response);
        if (response) {
          form.setFieldsValue(response);  // <-- This is correct
        }
      } catch (error) {
        showError('Failed to load email settings');
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, [form]);

  return (
    <Space direction="vertical" style={{ width: '100%' }} size="large">
      <Breadcrumb items={[{ title: 'Dashboard' }, { title: 'Email Settings' }]} />
      <Row gutter={16} justify="center">
        <Col span={12}>
          <Card title="Email Settings">
            <Form
              layout="vertical"
              form={form}
              onFinish={handleSave}
              initialValues={{
                es_email_host: '',
                es_email_port: '',
                es_email_user: '',
                es_email_password: '',
              }}
            >
              <Form.Item
                label="SMTP Host"
                name="es_email_host"
                rules={[{ required: true, message: 'SMTP host is required' }]}
              >
                <Input placeholder="Enter SMTP host" />
              </Form.Item>

              <Form.Item
                label="SMTP Port"
                name="es_email_port"
                rules={[{ required: true, message: 'SMTP port is required' }]}
              >
                <Input placeholder="Enter SMTP port" />
              </Form.Item>

              <Form.Item
                label="Email User"
                name="es_email_user"
                rules={[{ required: true, message: 'Email user is required' }]}
              >
                <Input placeholder="Enter email user address" />
              </Form.Item>

              <Form.Item
                label="Email Password"
                name="es_email_password"
                rules={[{ required: true, message: 'Email password is required' }]}
              >
                <Input.Password placeholder="Enter email password" />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" block>
                  Save Email Settings
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </Space>
  );
};

export default EmailSettings;
